import { store } from "redux/store"

import { reset } from "redux/features/polling/pollingSlice"

class PollingService {
  getPolling = () => {
    const state = store.getState()
    const { polling } = state
    const { pollingId } = polling

    return pollingId
  }
  isPolling = () => {
    const pollingId = this.getPolling()

    return !!pollingId
  }
  resetPolling = () => {
    const { dispatch } = store

    dispatch(reset())
  }
}

export default new PollingService()
